<div
  *ngIf="!isSubsidiaryAccount"
  [ngClass]="{
    newsletter: !isSmallSize,
    newsletter_small: isSmallSize,
    whiteBg: (isNewPLPVariantRestyle$ | async) && isPLP,
    newsletter_full: isPLP
  }"
  [fxLayout]="isSmallSize ? 'column' : 'row wrap'"
  fxLayout.mm-mobile="column"
  fxLayout.mm-tablet="column"
  fxLayoutGap.mm-mobile="19px"
>
  <figure
    [ngClass]="{
      newsletter__imgcontainer: !isSmallSize,
      newsletter_small__imgcontainer: isSmallSize
    }"
  >
    <img [appLazyLoadImage]="isMobile ? newsLetterImageMobile : newsLetterImage" alt="newsletter" />
    <app-newsletter-bubble
      [voucherType]="newsLetterVoucherType"
      [amount]="newsLetterAmount"
      [market]="market"
      [NLDiscount]="NLDiscount"
    ></app-newsletter-bubble>
  </figure>
  <div
    [ngClass]="{
      newsletter__content: !isSmallSize,
      newsletter_small__content: isSmallSize
    }"
  >
    <ng-container *ngIf="!isFormSubmitted; else submitConfirmationTemplate">
      <p class="newsletter__content__header">
        <span *ngIf="newsLetterTitle">{{ newsLetterTitle }}*</span>
        <span *ngIf="!newsLetterTitle"> {{ 'HOME.HOME_PAGE.NEWSLETTER_VOUCHER.HEADER' | translate: { discount: NLDiscount } }}* </span>
      </p>
      <p class="newsletter__content__subheader">
        {{ 'HOME.HOME_PAGE.NEWSLETTER.SUBHEADER' | translate }}
      </p>
      <form [formGroup]="form" (submit)="onSubmit()" fxLayout="row wrap" fxLayoutGap.mm-tablet="10px">
        <div fxFlex="67%" fxFlex.mm-tablet="65%">
          <mm-field>
            <input
              mmInput
              type="text"
              formControlName="email"
              placeholder="{{ 'HOME.HOME_PAGE.NEWSLETTER.EMAIL_PLACEHOLDER' | translate }}"
            />
          </mm-field>
          <mm-error fieldName="email">
            {{ 'CATALOG.DETAILS_PAGE.BUYBOX.OUT_OF_STOCK.VALIDATION' | translate }}
          </mm-error>
        </div>
        <div fxFlex="33%">
          <button
            mm-button
            type="submit"
            class="newsletter__content__button"
            [ngClass]="{ newsletter__content__button__active: isLoading }"
            [color]="'primary'"
          >
            <span *ngIf="!isLoading">{{ 'HOME.HOME_PAGE.NEWSLETTER.BUTTONTEXT' | translate }}</span>
            <mm-icon name="check" *ngIf="isLoading"></mm-icon>
          </button>
        </div>
      </form>
      <p
        class="newsletter__content__consent"
        [innerHTML]="
          getNewsletterContent(
            'HOME.HOME_PAGE.NEWSLETTER.LEGALTEXT' | translate,
            'HOME.HOME_PAGE.NEWSLETTER.PRIVACY_POLICY' | translate,
            'HOME.HOME_PAGE.NEWSLETTER.PROMO_TEXT' | translate,
            'HOME.HOME_PAGE.NEWSLETTER.PROMO_LINK_TEXT' | translate
          ) | sanitize
        "
      ></p>
    </ng-container>
  </div>
</div>

<ng-template #submitConfirmationTemplate>
  <ng-container>
    <p class="newsletter__content__header">
      {{ 'HOME.HOME_PAGE.NEWSLETTER.CONFIRMATION_HEADER' | translate }}
    </p>
    <p class="newsletter__content__subheader-confirm">
      {{ 'HOME.HOME_PAGE.NEWSLETTER.CONFIRMATION_SUBHEADER' | translate }}
    </p>
    <div class="newsletter__content__confirm">
      <p class="newsletter__content__email">
        {{ form.value.email }}
      </p>
      <p class="newsletter__content__submit-text">
        {{ 'HOME.HOME_PAGE.NEWSLETTER.CONFIRMATION_MESSAGE' | translate }}
      </p>
      <p class="newsletter__content__email-link">
        <a (click)="resendEmail()">{{ 'HOME.HOME_PAGE.NEWSLETTER.EMAIL_RESEND_TEXT' | translate }}</a>
        <mm-icon class="newsletter__content__resend-success" name="check" *ngIf="resend"></mm-icon>
      </p>
    </div>
  </ng-container>
</ng-template>
